import { useContext } from "react";
import PropTypes from "prop-types";
import SelectableButton from "src/components/buttons/SelectableButton/SelectableButton";
import { GridKeikka_NewKeikkaContext } from "src/context/GridKeikka_NewKeikkaContext";
import "../gridKeikka_NewKeikka_Styles.css";
import { SourceIcon } from "src/components/icons/KeikkaIcons";
import GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv from "../../GridKeikkaEditor/components/GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv";
import { Paper } from "@mui/material";
import { AsetuksetIcon } from "src/components/icons/StepIcons";

export default function GridKeikka_NewKeikka_SourceAsiakasSelector({ onAddClick = () => {} }) {
  const { sourceAsiakas, setSourceAsiakas, sourceAsiakasList } = useContext(
    GridKeikka_NewKeikkaContext
  );

  const handleAddClick = () => onAddClick("source");

  return (
    <Paper elevation={7}>
      <div className="newKeikka_paper" style={{ paddingBottom: "4px" }}>
        <GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv
          title="Tilauksen lähde"
          Icon={SourceIcon}
          ButtonIcon={AsetuksetIcon}
          onAddClick={handleAddClick}
          tooltipProps={{ title: "Hallitse tilauksen lähteitä", placement: "top" }}
        />
        <div
          className="newKeikka_buttonList"
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
          }}>
          {sourceAsiakasList.map((asiakas) => (
            <SelectableButton
              key={asiakas.sourceAsiakasId}
              checked={sourceAsiakas?.sourceAsiakasId === asiakas.sourceAsiakasId}
              onClick={() => setSourceAsiakas(asiakas)}>
              {asiakas?.sourceAsiakasNimi?.toUpperCase()}
            </SelectableButton>
          ))}
        </div>
      </div>
    </Paper>
  );
}

GridKeikka_NewKeikka_SourceAsiakasSelector.propTypes = {
  onAddClick: PropTypes.func,
};
